'use client'

import { IconMail } from '@tabler/icons-react'

import { useCustomerData } from '../hooks/useCustomerData'

import ProfileDetailsSingleItem from './ProfileDetailsSingleItem'

const CustomerEmailUpdateForm = () => {
  const { user } = useCustomerData()

  return (
    <ProfileDetailsSingleItem
      id='profile_edit_email'
      modalTitle='Edytuj adres email'
      icon={<IconMail />}
      label='Adres email'
      value={user?.email || '---'}
      values={{}}
      isButtonDisabled
      openCallback={() => {}}
    >
      email form
    </ProfileDetailsSingleItem>
  )
}

export default CustomerEmailUpdateForm
